import Project from '@/components/Project';
import Layout from '@/components/Layout';
Project.getLayout = function getLayout(page) {
    return (
        <Layout webViewMobile={true} web='project' >{page}</Layout>
    );
};

export async function getServerSideProps(context) {
    const UA = context.req.headers['user-agent'];
    const isMobile = Boolean(UA.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    ));
    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_API_SERVER_URL}/app/project/get-list-project?page=1&limit=10`, {
            headers: {
                'Content-Type': 'application/json',
                locale: context.locale

            }
        });

        const data = await res.json();
        if (!data || data.code !== 200) {
            return {
                notFound: true,
            };
        }
        const res_field = await fetch(`${process.env.NEXT_PUBLIC_API_SERVER_URL}/app/project/get-tag-by-type?type=FIELD`, {
            headers: {
                'Content-Type': 'application/json',
                locale: context.locale

            },
            method: 'get'
        });
        const data_field = await res_field.json();
        const res_language = await fetch(`${process.env.NEXT_PUBLIC_API_SERVER_URL}/app/project/get-tag-by-type?type=LANGUAGE`, {
            headers: {
                'Content-Type': 'application/json',
                locale: context.locale

            },
            method: 'get'
        });
        const data_language = await res_language.json();
        return {
            props: { ...data.data, data_field, data_language, sign: context.locale }, // will be passed to the page component as props
        };
    } catch (error) {
        console.log(error);
        return {
            notFound: true,
        };
    }

}

export default Project;


